import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import en_ja from '../../translations/en_ja';

const SearchBar = ({
    value,
    onChange,
    width = "350px",
    placeholder
}) => {

    return (
        <TextField
            size="small"
            placeholder={placeholder ? placeholder : en_ja["Search"]}
            value={value}
            onChange={onChange}
            sx={{
                width: width,
                "& .MuiOutlinedInput-root": {
                    fontSize: "14px",
                    backgroundColor: "white",
                    borderRadius: "12px",
                    transition: "all 0.2s ease",
                    "& fieldset": {
                        borderColor: "#e9ecef",
                        transition: "border-color 0.2s ease",
                    },
                    "&:hover": {
                        transform: "scale(1.02)",
                        "& fieldset": { borderColor: "#dc3545" },
                        "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                            color: "#dc3545",
                        },
                    },
                    "&.Mui-focused": {
                        transform: "scale(1.02)",
                        "& fieldset": { borderColor: "#dc3545", borderWidth: "2px" },
                        "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                            color: "#dc3545",
                        },
                    },
                },
            }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon
                            sx={{
                                color: "#6c757d",
                                fontSize: "20px",
                                transition: "color 0.2s ease",
                            }}
                        />
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default SearchBar;
